module.exports = __webpack_public_path__ + "img/tclogo.d192f5a6.png";